import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { UsersModal } from "./UsersModal";
import NotificationService from '../../services/Notification'
import { DateTime } from "luxon";
export const SendNotification = ({ isOpen, onClose, id, func }: any) => {
    const {  onOpen } = useDisclosure();
    const [selectedOption, setSelectedOption] = useState("all"); 
    // const [button,setButton] = useState()
    const [modal, setModal] = useState("");
    const handleOptionChange = (value: string) => {
      setSelectedOption(value);
    };

    function getFormattedDateTime() {
      const now = DateTime.local().setZone('Asia/Kolkata');
      const formattedDate = now.toFormat('MM/dd/yyyy');
  
      const formattedTime = now.toFormat('hh:mm a');
  
      return {
        date: formattedDate,
        time: formattedTime
      };
    }

    const closeModal = () =>{
      setModal("");
      onClose();
    }
    const handleSubmit = () =>{
        if(selectedOption==="all"){
          const data = {
            notification_id:id,
            application_type:"USER",
            lead_ids:[],
            notification_status:"PENDING",
            source:"MANUAL",
            schedule_date:getFormattedDateTime().date,
            schedule_time:getFormattedDateTime().time,
            variable_values:[],
            error:[],  
            target:"all" 
          };
          NotificationService.createNotifcationEvent(data).then((res)=>{
          })
          closeModal()
        }
        else{
            setModal('usermodal');
            onOpen()
        }
    }
  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Notification</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
        <RadioGroup onChange={handleOptionChange} value={selectedOption} >
            <Radio value="all"  marginRight={10}>All Users</Radio>
            <Radio value="specificUser">Select Users</Radio>
          </RadioGroup>
        </ModalBody>

        <ModalFooter>
          <Button bgColor="#327171" color={"white"} mr={3} onClick={handleSubmit}>
            {selectedOption === "all" ?"Send" : "Select User"}
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={closeModal}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
      {modal === "usermodal" && (
        <UsersModal
          isOpen={isOpen}
          onClose={onClose}
          func={closeModal}
          id={id}
        />
      )}
    </Modal>
  );
};
